module Meevo.Plugins.Register {
    "use strict";

    export class SpecifyEmployeeBaseSection extends Meevo.Plugins.Register.RegisterSectionBase {
        protected employees: any;
        protected filter: string = "";

        get endPoint() { return this.registerContext.appSettings.API_ENDPOINTS.employee; }
        get dataService() { return this.registerContext.dataService; }
        
        constructor(registerContext: Meevo.Plugins.Register.RegisterContext,
            protected showEmployeeFilter: boolean,
            sectionFolderName: string,
            sectionCategory: Register.RegisterSectionCatTypeEnum,
            sectionType: Register.RegisterSectionTypeEnum) {

            super(sectionType, registerContext, sectionFolderName, sectionCategory);
        }

        public getEmployees(excludeIds: any[] = []) {
            let criteria = {
                showEmployeesOnly: true,
                filter: this.filter,
                allowSales: true,
                excludeIdList: excludeIds
            };
            this.processCriteria(criteria);
            let request = {
                pageNumber: 0,
                itemsPerPage: 1000,
                sortDirection: Model.SortDirection.Ascending,
                criteria: criteria
            };
            return this.dataService.getListPaged(this.endPoint, request).then((response: any) => {
                this.employees = response;
            });
        }

        public processCriteria(criteria: any) {
            
        }
        public getEmployeesDebounce = _.debounce(() => {
            this.getEmployees();
        }, 300);

        public filterChange() {
            this.getEmployeesDebounce();
        }
    }

}